import CardSection from '../sections/CardSection';
import InputField  from '../form/InputField';

export default function NameSection({ data, onChange, errors }) {
    const isNatural = data.naturaleza === 'N';

    return (
        <CardSection icon="person" title="Nombre | Razón Social">
            <div className="row">
                {isNatural ? (
                    <>
                        <div className="col-md-6">
                            <InputField
                                id="primerNombre"
                                label="Primer Nombre"
                                placeholder="Ej. Juan"
                                value={data.primerNombre || ''}
                                onChange={onChange}
                                required
                                error={errors.primerNombre}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                id="segundoNombre"
                                label="Segundo Nombre"
                                placeholder="Opcional"
                                value={data.segundoNombre || ''}
                                onChange={onChange}
                                error={errors.segundoNombre}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                id="primerApellido"
                                label="Primer Apellido"
                                placeholder="Ej. Pérez"
                                value={data.primerApellido || ''}
                                onChange={onChange}
                                required
                                error={errors.primerApellido}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                id="segundoApellido"
                                label="Segundo Apellido"
                                placeholder="Opcional"
                                value={data.segundoApellido || ''}
                                onChange={onChange}
                                error={errors.segundoApellido}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="col-md-6">
                            <InputField
                                id="razonSocial"
                                label="Razón Social"
                                placeholder="Ej. Mi Empresa S.A.S"
                                value={data.razonSocial || ''}
                                onChange={onChange}
                                required
                                error={errors.razonSocial}
                            />
                        </div>
                    </>
                )}
            </div>
        </CardSection>
    );
}